module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "signin"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "offset-sm4": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-container', {
    staticClass: "without-padding container-img"
  }, [_c('v-img', {
    attrs: {
      "src": require('../../assets/logoPonce.png')
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("¡" + _vm._s(_vm.$t('Signin.setAccountData')) + "!")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignin.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-email",
    attrs: {
      "prepend-inner-icon": "mail",
      "name": "email",
      "label": _vm.$t('Signin.email'),
      "id": "email",
      "type": "email",
      "color": "#00202F",
      "rules": _vm.$ponceConfig.emailRules,
      "validate-on-blur": "",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-password",
    attrs: {
      "prepend-inner-icon": "lock",
      "name": "password",
      "label": _vm.$t('Signin.password'),
      "id": "password",
      "type": "password",
      "color": "#00202F",
      "rules": _vm.$ponceConfig.passwordRules,
      "validate-on-blur": "",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), (_vm.showError) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('p', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.$t('Signin.wrongSigninDataHint')))])]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "div-reset-password",
    attrs: {
      "row": ""
    }
  }, [_c('a', {
    staticClass: "text-reset-password",
    on: {
      "click": _vm.passRecovery
    }
  }, [_vm._v(_vm._s(_vm.$t('Signin.forgotPassword')))])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "submit-btn",
    attrs: {
      "block": "",
      "color": "info",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('Signin.enter')))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-div"
  }, [_c('p', {
    staticClass: "bottom-text"
  }, [_vm._v("PONCE")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcb613d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signin.vue
// module id = 1752
// module chunks = 0